import { Button, DialogContent, DialogFooter, DialogHeader, DialogRoot, Search as SearchInput } from '@ibsys/kit';
import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SpotlightBodyBase } from './SpotlightBodyBase';

export type SpotlightDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  shortcut: string;
};

export const SpotlightDialog: FC<SpotlightDialogProps> = (props) => {
  const { isOpen, onOpenChange, shortcut } = props;
  const { t } = useTranslation(['common']);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (isOpen) {
      // small delay to ensure dialog mounted
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [isOpen]);

  return (
    <DialogRoot open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="max-w-[720px] w-[92vw] bg-card min-h-140 pb-0 px-0 flex flex-col overflow-hidden pt-2"
        showOverlay={true}
      >
        <DialogHeader className={'border-border border-b py-5 pt-6 px-5'}>
          <SearchInput
            ref={inputRef as any}
            placeholder={t('search')}
            classNames={{ input: 'bg-transparent border-t-none border-b placeholder-lg' }}
          />
        </DialogHeader>

        <SpotlightBodyBase />

        <DialogFooter className="flex items-center justify-between mt-3 p-5 pb-2 ">
          <div className="text-xs text-muted-foreground">{`${t('shortcut', { defaultValue: 'Shortcut' })}: ${shortcut}`}</div>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            {t('common:close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
